import React from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import CustomSwitch from '../CustomizedUIs/GreenSwitch'
import Arrow from '../assets/icons/white-arrow-left.png'
import GoBackButton from '../CustomizedUIs/GoBackButton';

const useStyles = makeStyles((theme) =>
    createStyles({
        expandText: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '9px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.22,
            letterSpacing: '0.36px',
            color: '#4f5064',
            padding: '5px 8px 5px 8px'
        }, expandGroup: {
            width: 150,
            height: 30,
            float: 'right',
            backgroundColor: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
        },
        TextBack: {
            fontFamily: 'UniviaPro-Medium',
            fontSize: '15px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
        },
        TitleName: {
            fontFamily: 'UniviaPro-Medium',
            fontSize: '18px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            color: '#4f5064',
        },
        BoxExpand: {
            width: '134px',
            height: '30px',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
        },
      

    }),
);

const IconTitle = ({ TitleBack, TitleName, expandAll, onExpandAllChanged }) => {
    const translate = useTranslate();
    const history = useHistory();
    const classes = useStyles();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    // const GoBack =()=>{
    //     history.goBack()
    // }


    return (
        <Box my={2} width="100%">
            <Box my={5} width={300} display='flex' component={Link} to={{ pathname: "/roles" }} style={{ textDecoration: 'none' }}>
                <Box display='flex' mr={2}>
                    <GoBackButton/>
                </Box>
                <Typography color='primary' className={classes.TextBack} style={{ margin: 'auto 0' }}>{TitleBack}</Typography>
            </Box>
            <Box display="flex" width='100%' justifyContent='center'>
                <Box display="flex" width='700px' alignItems='center'>
                    <Box display="flex" marginRight="auto">
                        <Typography className={classes.TitleName} style={{ margin: 'auto 0' }}>{TitleName}</Typography>

                    </Box>
                    <Box display='flex' marginLeft='auto' >
                        <Box pl={2} alignItems='center' display='flex' className={classes.BoxExpand}  >
                            <Typography className={classes.expandText} >{translate('resources.role.expandall')}</Typography>
                            <CustomSwitch color="primary" size="small" checked={expandAll} onChange={onExpandAllChanged} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>


    )
}
export default IconTitle;